import React, { FunctionComponent } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { TranslateScope } from '@pegasus/translation';
import { hideNotification } from '@client/redux/modules/flashMessage/actions';
import { getShowNotification } from '@client/redux/modules/flashMessage/selectors';
import { getEmail } from '@client/redux/modules/customer';
import { Notification } from '@pegasus/platform-journeys';
import * as S from './styles';

export const Notifications: FunctionComponent<{}> = () => {
    const dispatch = useDispatch();
    const email = useSelector(getEmail);
    const showNotification = useSelector(getShowNotification);

    if (!showNotification) {
        return null;
    }

    return (
        <S.NotificationWrapper>
            <TranslateScope path="checkEmailNotification">
                <Notification hideNotification={() => dispatch(hideNotification())} email={email} />
            </TranslateScope>
        </S.NotificationWrapper>
    );
};

export default Notifications;
